import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const TRADES = [
  { icon: '🔧', label: 'Plumbing', desc: 'Leaks, clogs, water heaters' },
  { icon: '⚡', label: 'Electrical', desc: 'Wiring, outlets, panels' },
  { icon: '❄️', label: 'HVAC', desc: 'Heating, cooling, thermostats' },
  { icon: '🔨', label: 'Handyman', desc: 'Drywall, doors, painting' },
  { icon: '🌿', label: 'Landscaping', desc: 'Mowing, trimming, cleanup' },
  { icon: '✨', label: 'Cleaning', desc: 'Deep clean, move-in/out' },
];

export default function Landing() {
  const { user } = useAuth();

  return (
    <div style={{ background: 'var(--color-warm-white)' }}>
      {/* Hero */}
      <section style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', minHeight: '80vh', textAlign: 'center',
        padding: 'var(--space-3xl) var(--space-xl)',
        background: 'linear-gradient(180deg, var(--color-cream) 0%, var(--color-warm-white) 100%)',
      }}>
        <img src="/assets/logo-icon.svg" alt="WorkDoe Mascot" style={{ width: 120, height: 120, marginBottom: 'var(--space-lg)' }} />
        <h1 style={{ fontSize: '3rem', fontWeight: 800, color: 'var(--color-dark-brown)', marginBottom: 'var(--space-sm)', fontFamily: 'var(--font-family)' }}>
          WorkDoe
        </h1>
        <p style={{ fontSize: '1.4rem', color: 'var(--color-brown)', fontWeight: 500, marginBottom: 'var(--space-2xl)', fontStyle: 'italic' }}>
          Doe's anyone work around here?
        </p>
        <p style={{ fontSize: '1.1rem', maxWidth: 560, marginBottom: 'var(--space-2xl)', color: 'var(--color-dark-brown)', opacity: 0.8 }}>
          On-demand home services in 4 taps. Find plumbers, electricians, HVAC technicians, and more — dispatched to your door.
        </p>
        <Link to={user ? '/send-a-doe' : '/login'}>
          <button className="btn-send-a-doe">
            <span className="doe-icon">🦌</span>
            <span className="doe-label">Send a Doe</span>
            <span className="doe-sublabel">Get help now</span>
          </button>
        </Link>
      </section>

      {/* Trades Grid */}
      <section style={{ padding: 'var(--space-3xl) var(--space-xl)', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.8rem', fontWeight: 700, color: 'var(--color-dark-brown)', marginBottom: 'var(--space-xl)' }}>
          What kind of Doe do you need?
        </h2>
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: 'var(--space-lg)', maxWidth: 800, margin: '0 auto',
        }}>
          {TRADES.map(trade => (
            <div key={trade.label} className="card" style={{ textAlign: 'center', cursor: 'pointer' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: 'var(--space-sm)' }}>{trade.icon}</div>
              <h3 style={{ fontWeight: 600, marginBottom: 'var(--space-xs)' }}>{trade.label}</h3>
              <p style={{ fontSize: '0.85rem', opacity: 0.7 }}>{trade.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* How It Works */}
      <section style={{
        padding: 'var(--space-3xl) var(--space-xl)', textAlign: 'center',
        background: 'var(--color-cream)',
      }}>
        <h2 style={{ fontSize: '1.8rem', fontWeight: 700, color: 'var(--color-dark-brown)', marginBottom: 'var(--space-xl)' }}>
          4 taps. That's it.
        </h2>
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: 'var(--space-xl)', maxWidth: 900, margin: '0 auto',
        }}>
          {[
            { step: '1', title: 'Send a Doe', desc: 'Tap the big button and pick your Doe type' },
            { step: '2', title: 'Describe it', desc: 'Pick the problem chip + urgency + budget' },
            { step: '3', title: 'Compare bids', desc: 'Up to 3 contractors respond with quotes on a visual scale' },
            { step: '4', title: 'Pick & chat', desc: 'Choose your Doe, chat, and get it fixed' },
          ].map(item => (
            <div key={item.step} style={{ padding: 'var(--space-lg)' }}>
              <div style={{
                width: 48, height: 48, borderRadius: '50%',
                background: 'var(--color-brown)', color: 'var(--color-cream)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '1.3rem', fontWeight: 700, margin: '0 auto var(--space-md)',
              }}>{item.step}</div>
              <h3 style={{ fontWeight: 600, marginBottom: 'var(--space-xs)' }}>{item.title}</h3>
              <p style={{ fontSize: '0.9rem', opacity: 0.7 }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: 'var(--space-3xl) var(--space-xl)', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: 'var(--space-lg)' }}>
          Ready to get to work?
        </h2>
        <div style={{ display: 'flex', gap: 'var(--space-md)', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/login">
            <button className="btn-primary">I Need Help</button>
          </Link>
          <Link to="/login">
            <button className="chip" style={{ fontSize: '1rem', padding: '12px 24px' }}>I'm a Contractor</button>
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Moose Bay &amp; Company LLC · Virginia, USA</p>
        <p>
          <Link to="/privacy">Privacy</Link> · <Link to="/terms">Terms</Link> · <Link to="/security">Security</Link>
        </p>
        <p className="disclaimer" style={{ marginTop: 'var(--space-sm)', maxWidth: 600, margin: '8px auto 0' }}>
          WorkDoe is a matching platform only. We are not responsible for the quality, safety, or completion of any work performed, nor for any payments exchanged between homeowners and contractors.
        </p>
      </footer>
    </div>
  );
}
